import { BenefitRow } from "entities/benefits";
import { Title } from "pages/ui/page";
import AIIcon from "shared/assets/svgs/ai.svg?react";
import BellIcon from "shared/assets/svgs/bell.svg?react";
import DownloadIcon from "shared/assets/svgs/download.svg?react";
import TaskIcon from "shared/assets/svgs/tasks.svg?react";

export const BenefitsSlide = () => {
  return (
    <div className="w-full shrink-0 px-4 pt-7.5">
      <Title>Key Benefits of Resonar AI</Title>
      <ul className="mt-5 flex flex-col gap-4">
        <BenefitRow
          title="AI Personal Assistant"
          description="Sync and manage your Google and iCloud calendars, mail, and contacts."
          icon={<AIIcon className="text-crystal-blue size-10.5 shrink-0" />}
        />
        <BenefitRow
          title="Smart Task Manager"
          description="Turn messages into organized todo lists and daily schedules automatically."
          icon={<TaskIcon className="text-crystal-blue size-10.5 shrink-0" />}
        />
        <BenefitRow
          title="Multi-Modal Input"
          description="Send voice, images, videos, docs or links — Resonar acts on any format."
          icon={
            <DownloadIcon className="text-crystal-blue size-10.5 shrink-0" />
          }
        />
        <BenefitRow
          title="Autonomous Routines"
          description="Set routine reminders and autonomous workflows to handle your errands."
          icon={<BellIcon className="text-crystal-blue size-10.5 shrink-0" />}
        />
      </ul>
    </div>
  );
};
